import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeMarketingDepartment: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'Marketing',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Video ads',
        },
        {
            label: 'Social Media',
        },
        {
            label: 'Product guides',
        },
        {
            label: 'Video presentations',
        },
        {
            label: 'Interactive conversational Avatars',
        },
        {
            label: 'Internal and external communications',
        },
        {
            label: 'Email campaigns',
        },
        {
            label: 'Localized content',
        },
        {
            label: 'AI innovation',
        },
        {
            label: 'Other',
        },
    ],
};
